{
  "error": "Feil",
  "help": "Hjelp",
  "info": "Informasjon",
  "success": "Vellykket",
  "warning": "Advarsel"
}
